import api from './api';

// Gerar ou recuperar ID de sessão único
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('bf_session_id');
  if (!sessionId) {
    sessionId = 'sess_' + Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
    sessionStorage.setItem('bf_session_id', sessionId);
  }
  return sessionId;
};

// Registrar visita de página
export const trackPageView = async (page) => {
  try {
    await api.post('/analytics/visit', {
      page: page || window.location.pathname,
      referrer: document.referrer || null,
      user_agent: navigator.userAgent
    }, {
      headers: {
        'X-Session-ID': getSessionId()
      }
    });
  } catch (error) {
    console.error('Error tracking page view:', error);
  }
};

// Registrar instalação do PWA
export const trackPWAInstall = async () => {
  try {
    const deviceInfo = {
      platform: navigator.platform,
      userAgent: navigator.userAgent,
      language: navigator.language,
      screenWidth: window.screen.width,
      screenHeight: window.screen.height
    };
    
    await api.post('/analytics/pwa-install', {
      device_info: JSON.stringify(deviceInfo)
    }, {
      headers: {
        'X-Session-ID': getSessionId()
      }
    });
    
    // Marcar como já registrado
    localStorage.setItem('bf_pwa_installed', 'true');
  } catch (error) {
    console.error('Error tracking PWA install:', error);
  }
};

// Heartbeat para manter usuário como "online"
let heartbeatInterval = null;

export const startHeartbeat = () => {
  if (heartbeatInterval) return;
  
  const sendHeartbeat = async () => {
    try {
      await api.post('/analytics/heartbeat', {}, {
        headers: {
          'X-Session-ID': getSessionId()
        }
      });
    } catch (error) {
      // Silenciar erros de heartbeat
    }
  };
  
  // Enviar heartbeat imediatamente
  sendHeartbeat();
  
  // Enviar a cada 2 minutos
  heartbeatInterval = setInterval(sendHeartbeat, 2 * 60 * 1000);
};

export const stopHeartbeat = () => {
  if (heartbeatInterval) {
    clearInterval(heartbeatInterval);
    heartbeatInterval = null;
  }
};

// Verificar se PWA foi instalado e registrar
export const checkAndTrackPWAInstall = () => {
  // Verificar se já foi registrado
  if (localStorage.getItem('bf_pwa_installed')) return;
  
  // Verificar se está rodando como PWA
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
                       window.navigator.standalone === true;
  
  if (isStandalone) {
    trackPWAInstall();
  }
  
  // Listener para quando o usuário instalar
  window.addEventListener('appinstalled', () => {
    trackPWAInstall();
  });
};

export default {
  trackPageView,
  trackPWAInstall,
  startHeartbeat,
  stopHeartbeat,
  checkAndTrackPWAInstall
};
